<div id="search_field">
    <input #search spellcheck="false" class="search-field" placeholder="{{placeholder}}" 
    [value]="preData || ''"
        (keypress)="onKeyPressed()" (keyup)="onKeyUp(search)" type="text">
    <svg class="down" role="img" title="search" class="search-icon">
        <use href="assets/images/sprite.svg#icon-search"></use>
    </svg>
</div>